import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16622 16978"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970271483072">
        <path
          d="m5595 13582 1293-3331c98-259-97-549-388-549H2037V6468h4463c291 0 485-292 388-550L5595 2587l9539 5498-9539 5497zm10542-5853L5013 1293c-162-97-324-64-453 33s-162 291-130 453l1488 3848H1649c-226 0-420 194-420 420v4043c0 226 194 420 420 420h4269l-1487 3848c-65 162-33 356 129 453 129 97 323 129 453 33l11124-6436c259-129 259-550 0-679zM13550 808c550 0 1002 453 1002 1003 0 549-420 1002-1002 1002s-1002-453-1002-1002c0-550 452-1003 1002-1003zm0 2814c1002 0 1811-809 1811-1811 0-1003-809-1811-1811-1811s-1811 808-1811 1811c0 1002 809 1811 1811 1811zM11739 15749c-453 0-808-356-808-809 0-452 355-808 808-808s809 356 809 808c0 453-356 809-809 809zm0-2426c-905 0-1617 712-1617 1617 0 906 711 1617 1617 1617s1617-711 1617-1617c0-905-711-1617-1617-1617zM1229 13743c-226 0-421-193-421-420 0-226 195-420 421-420s420 194 420 420c0 227-194 421-420 420zm0-1616c-679 0-1229 550-1229 1229s550 1229 1229 1229 1229-550 1229-1229-550-1229-1229-1229zM15490 14681c232 0 421 189 421 421s-189 420-421 420-420-188-420-420 188-421 420-421zM16201 4430c233 0 421 188 421 421 0 232-188 420-421 420-231 0-420-188-420-420 1-233 189-421 420-421zM8926 776c231 0 420 188 420 420 0 233-189 421-420 421-232 0-421-188-421-421 0-232 188-420 421-420zM1229 2005c232 0 420 188 420 420 0 233-188 421-420 421s-421-188-421-421c0-232 188-420 421-420zM2846 16137c232 0 420 188 420 420s-188 421-420 421-421-189-421-421 189-420 421-420z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
